import * as React from "react";
import styled from "styled-components";
import {Box} from "@material-ui/core";
import {Colors} from "../../theme/colors";

export const BoxHeader: React.FC<Props> = ({title}) => (
    <>
        <StyledBox display={'flex'} flexDirection={'row'}>
            <StyledTitle>{title}</StyledTitle>
        </StyledBox>
    </>
);

const StyledBox = styled(Box)`

`;

const StyledTitle = styled('h6')`
  font-weight: bold;
  color: ${Colors.lightViolet};
  font-size: 1.2rem;
  padding: 0;
`;

interface Props {
    title: string;
}
